//variation items data and population script

if($('.swatch-links').length) {
  
$('.swatch-links').on('click', '.swatch-element', function(e) {
    e.preventDefault();
    var href = $(this).closest('a.item').attr('href');
    if(href != undefined) {
      window.location.href = href;
      return false;
    }
  });

  var motimer;
  $('.swatch-links .swatch-element').hover( function(e) {
    
    var $productSlider = $(".flexslider.product_gallery");
    if(typeof $productSlider.flexslider != 'function') {          
      return;
    }
  var _self = $(this);
    clearTimeout(motimer);
    var $this = $(this);
    var header = $this.closest('.swatch-links').find('.header .current');
   
    if($this.data('value') !== '') {
      header.html(': ' + $this.data('value'));  
    } else {
      header.html(': ' + header.data('og'));
    }
    $this.closest('.swatch-links').find('.swatch-element').removeClass('current');
    $this.addClass('current');

    if($('.product_gallery.product_images .variation-image').length < 1) {
      var default_href = "data:image/svg+xml;utf8,svg%20xmlns='<http://www.w3.org/2000/svg'%20width='1000'%20height='1000'>/svg'";
      $('.product_gallery.product_images').append('<div class="variation-image-wrapper"><img src="'+default_href+'" class="variation-image"/></div>');
    }
    var image_src = $this.find('img').attr('src');
    if(image_src.indexOf('_150x') >= 0) {
      image_src =  image_src.replace('_150x','_1000x');
    }
    

    
    $('.variation-image').on('load.image', function(){    
      $('.product_gallery.product_images .variation-image-wrapper').css('width', "100%");
      $('.product_gallery.product_images .variation-image-wrapper').css('height', 'auto');
      $('.product_gallery.product_images').addClass('variation-hover');

      if ( /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){ 
        window.location.href = _self.closest("a").attr('href'); 
      }

    });
    $('.product_gallery.product_images .variation-image').attr('src', image_src);


  }, function(e) { 

    var $productSlider = $(".flexslider.product_gallery");
     if(typeof $productSlider.flexslider != 'function') {          
         return;
      }

    clearTimeout(motimer);
    var $this = $(this);
    var header = $this.closest('.swatch-links').find('.header .current');
    motimer = setTimeout(function() {
      
      header.html(': ' +  header.data('og'));
      
      $this.closest('.swatch-links').find('.swatch-element').removeClass('current');
      $this.closest('.swatch-links').find('.swatch-element:first').addClass('current');
	  $('.product_gallery.product_images').removeClass('variation-hover');
      $('.product_gallery.product_images .variation-image-wrapper').css('height', 0);
      $('.variation-image').off('load.image');
    }, 20);   
  });
  
  $('.flexslider.swatch-links').flexslider({
    animation: "slide",
    animationLoop: false,
    slideshow: false,
    itemWidth: 123.75,
    itemMargin: 5,
    controlNav: false,
    prevText: 'More',
    nextText: 'More',
    start: function(target) {
      $(target).addClass('loaded'); 
      $(target).find('.flex-direction-nav li').addClass('clearfix');
    }
  });  
}
